"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapIconInfo = void 0;
const mapIconInfo = exports.mapIconInfo = {
  pin: {
    width: 42,
    height: 50
  },
  pinSelected: {
    width: 46,
    height: 55
  },
  cluster: {
    width: 48,
    height: 48
  },
  currentLocation: {
    width: 50,
    height: 50
  }
};